module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("More Stories")]), _vm._v(" "), _vm._l((_vm.stories), function(story) {
    return _c('div', [_c('h5', {
      domProps: {
        "innerHTML": _vm._s(story.title)
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(story.content)
      }
    })])
  })], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "images"
  }, [_c('img', {
    attrs: {
      "src": require("assets/images/DSC_0481.jpeg")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("assets/images/DSC_0677.jpeg")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("assets/images/DSC_0197.jpeg")
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("assets/images/DSC_0775.jpeg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-173ff9a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurStory/MoreStories.vue
// module id = 376
// module chunks = 2